import styled from '@emotion/styled';
import React from 'react';

import NodeTask from './node-task';
import PythonTask from './python-task';

interface Props {
  className?: string;
}

const Demo: React.FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <NodeTask />
      <hr />
      <PythonTask />
    </div>
  );
};

export default styled(Demo)`
  background-color: white;
`;
